/**
 * Indicates the name of the audit checks related to documents
 * TODO: JBM - move to a common library, shared between backend and frontend
 */
export enum AuditCheckDocumentName {
    CheckDocumentDoublon = "CheckDocumentDoublon",
    CheckDocumentNotBalanced = "CheckDocNotBalanced",
    CheckDocumentOutsideActiveAccountingPeriods = "CheckDocumentOutsideActiveAccountingPeriods",
    CheckDocumentNoDate = "CheckDocumentNoDate",
}
